import _ from 'lodash';
import {
  useState,
  useEffect,
} from 'react';
import AiDeenService from '../../service_v2/aideen/aideen-service';

const resetOrUpdate = () => {
  const [ responseData, setResponseData ] = useState({ });
  const [ updateData, setUpdateData ] = useState(null);
  const {
    items,
    onOperationComplete,
  } = updateData || {};

 

  const addUpdateMediaItems = async () => {
    try {
      setResponseData({
        isUpdating: true,
        isError: false,
      });
      const exceUploadApiResp = await AiDeenService.updateAiDeenContent(items)
      // DailydeenService.updateDailyDeenContent(items);
      const responseData = exceUploadApiResp;

      let errorMsg = null;
      let isError = false;

      console.log("updating complete", responseData)


      if(responseData && responseData.success) {
        console.log('AiDeen media items add/update Success!!');
      } else {
        console.log('AiDeen media items add/update Failed!!');
        errorMsg = `Failed to add/update AiDeen media items.`;
        isError = true;
      }

      setResponseData({
        isUpdating: false,
        isError,
        errorMsg,
        data: responseData,
      });

      if(onOperationComplete) {
        onOperationComplete({
          isError,
          errorMsg,
          data: responseData,
        });
      }
    } catch (err) {
      console.log('Something went wrong while add/update AiDeen media items. ', err);
      const errorMsg = `Error occurred while add/update AiDeen media items.`;
      setResponseData({
        isUpdating: false,
        isError: true,
        errorMsg,
        data: null,
      });
      if(onOperationComplete) {
        onOperationComplete({
          isError: true,
          errorMsg,
          data: null,
        });
      }
    }
  };

  useEffect( () => {
    if(!_.isEmpty(updateData)) {
      addUpdateMediaItems();
    }
    console.log('Updating')
  }, [ updateData ]);

  return [
    responseData,
    setUpdateData,
  ];
};

export default resetOrUpdate;